import useResources from "./use-resources";

export default function useTenantDocumentSynthese() {
  const {
    resources: tenantDocumentSynthese,
    error,
    isLoading,
    mutate,
  } = useResources("/documents/tenant-synthese");

  return {
    tenantDocumentSynthese,
    error,
    isLoading,
    mutate,
  };
}
